import { createClient } from '@sanity/client';
import { env } from '$env/dynamic/public';

const environment = env.PUBLIC_ENVIRONMENT ?? 'development';

const getSanityUrl = () => {
  switch (environment) {
    case 'staging':
      return 'https://sanity-block-web.stage.sqprod.co';
    case 'production':
      return 'https://sanity-block-web.sqprod.co';
    default:
      return 'http://localhost:3333';
  }
};

export const sanityStudioURL = getSanityUrl();

export const client = createClient({
  projectId: '8m3angk4',
  apiVersion: '2023-06-29',
  dataset: environment,
  useCdn: false,
  stega: {
    studioUrl: sanityStudioURL
  }
});
